<template>

  <div>    
    <vs-popup title="Lista de Pedidos Selecionados" :active.sync="popUpSelecao.popupActive">
          
          <vs-table :data="listaPedidosSelecionados" pagination max-items="5" noDataText="Nenhum pedido selecionado." stripe search>
            <template slot="thead">
                <vs-th>PEDIDO</vs-th>
                <vs-th>DATA</vs-th>            
                <vs-th><span class="w-full" style="text-align:center !important;"> VENDEDOR </span></vs-th>            
                <vs-th></vs-th>  
            </template>

            <template slot-scope="{data}"> 
                <vs-tr :key="tr.id" v-for="(tr) in data" :data="tr">
                    <vs-td :data="tr.numeroPedido"  style="padding: 1px;">
                        <small>{{tr.numeroPedido}}</small>                   
                    </vs-td>
                    <vs-td :data="tr.dataPedidoFormatada"  style="padding: 1px;">
                        <small>{{tr.dataPedidoFormatada}}</small>
                    </vs-td>   
                    <vs-td :data="tr.nomeVendedor"  style="padding: 1px;" class="text-center">
                        <small>{{tr.nomeVendedor}}</small>
                    </vs-td>   
                    <vs-td :data="tr.dataPedidoFormatada"  style="padding: 1px;">
                        <vs-button size="small" color="danger" icon-pack="feather" icon="icon-minus" @click="removerPedido(tr)"></vs-button>             
                    </vs-td>
                </vs-tr>
            </template>
          </vs-table> 
          <vx-input-group>
                <template slot="prepend">
                <div class="prepend-text bg-primary">
                    <vs-button color="primary" icon-pack="feather" icon="icon-tag" @click="gerarNumeroCarregamento"></vs-button>
                </div>
                </template>
                <vs-input v-model="popUpSelecao.numeroCarregamento" placeholder="Número do Carregamento" class="w-full" />
          </vx-input-group>
          
          <vs-row vs-type="flex" vs-justify="space-between" class="mt-4">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <vs-button color="dark" @click="enviarRequisicao(ACAO_EXCLUIR_EM_LOTE)" class="ml-2" :disabled="!temPermissaoGravar && !temCapacidadeMaster || !listaPedidosSelecionados.length" icon="delete"><small>Excluir em Lote </small></vs-button>
                  <vs-button color="dark" @click="enviarRequisicao(ACAO_CRIAR_CARREGAMENTO)" class="ml-2" :disabled="!temPermissaoGravar && !temCapacidadeMaster || !listaPedidosSelecionados.length || !popUpSelecao.numeroCarregamento"> <small>Criar Carregamento </small></vs-button>
                  <vs-button color="warning" @click="limparListaSelecao" class="ml-2" :disabled="!listaPedidosSelecionados.length" icon="clear"> </vs-button>
              </vs-col>
          </vs-row>
      </vs-popup> 
    <vx-card ref="filterCard" :title="$t('Filtros')" class="mb-2" :collapse-action="true" >

     <vs-row vs-type="flex" vs-justify="space-between" class="mb-3">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lVendedor')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
            <v-select                                     
                  label="nome"  
                  :options="listaVendedores"                   
                  v-model="filtro.vendedor"       
                  class="v-select w-full"></v-select> 
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lLoja')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
            <v-select                                     
                  label="nome"
                  :options="listaLojas"                   
                  v-model="filtro.loja"       
                  class="v-select w-full"></v-select> 
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lZona')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
            <v-select
                  label="nome"                              
                  :options="listaZonas" 
                  v-model="filtro.zona"                        
                  class="v-select w-full"></v-select> 
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lPedido')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
            <vs-input class="mb-4 md:mb-0 w-full" v-model="filtro.numeroPedido" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lCarregamento')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
            <vs-input class="mb-4 md:mb-0 w-full" v-model="filtro.numeroCarregamento" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
          <label class="vs-input--label">{{$t('TelaPedido_lLote')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">          
            <vs-input class="mb-4 md:mb-0 w-full" v-model="filtro.numeroLote" />
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between" class="mt-2">        
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
            <v-select                   
                :reduce="tipo => tipo.data" 
                :options="listaOpcoesFiltroData" 
                v-model="filtro.tipoDataPesquisa"       
                :clearable="false"
                class="v-select w-full text-sm mr-2"></v-select> 
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">
            <flat-pickr v-model="filtro.dataInicio" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
            <label class="vs-input--label">à</label>
            <flat-pickr v-model="filtro.dataFim" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
            <label class="ml-2  text-sm opacity-75">{{$t("TelaPedido_lStatus")}}</label>
        </vs-col>                      
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">
           <v-select                   
              :reduce="tipo => tipo.data" 
              :options="listaOpcoesFiltroStatusItinerario" 
              v-model="filtro.statusItinerario"                     
              class="v-select w-full text-sm"></v-select>            
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">              
          <vs-checkbox v-model="filtro.semCelular"><small>Sem celular ?</small></vs-checkbox>        
          <vs-checkbox v-model="filtro.naoRoteirizados"><small> Não roteirizados ?</small></vs-checkbox>        
        </vs-col>                      
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
          <vx-tooltip text="Pedidos selecionados para alteração em lote.">              
            <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6" :badge="listaPedidosSelecionados.length" @click="abrirPopUpSelecao" />
          </vx-tooltip>

          <vx-tooltip :text="$t('Pesquisa')">              
            <vs-button class="mr-2" radius color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>          
          </vx-tooltip>
          <vx-tooltip :text="$t('LimparFiltros')">              
            <vs-button class="mr-2" radius color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
          </vx-tooltip>          
          <vx-tooltip :text="$t('Novo')">              
            <vs-button class="mr-2" radius color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>      
          </vx-tooltip>          
          <vx-tooltip :text="$t('ExportarParaCSV')">                  
            <vs-button class="mr-2" radius color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV"></vs-button>  
          </vx-tooltip>          
          
        </vs-col>    
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between" class="mt-2" v-if="exibirErro">        
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
            <vs-alert :active.sync="exibirErro" closable color="danger" icon-pack="feather" icon="icon-info" close-icon="icon-x">
               {{mensagemErro}}
            </vs-alert> 
        </vs-col>
      </vs-row>
    </vx-card>

     <vx-card>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :headerHeight="25"
        :rowHeight="50"
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"     
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationAutoPageSize="true"
        :suppressPaginationPanel="true"
        :context="configuracaoGrid.context"        
        >
      </ag-grid-vue>
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
          <div class="p-2 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg flex items-center justify-between font-medium text-sm">
            <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ dadosDaGrid.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : dadosDaGrid.length }} de {{ dadosDaGrid.length }}</span>              
          </div>
        </vs-col>

        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="text-sm" />
        </vs-col>
      </vs-row>
    </vx-card>     
  </div>

</template>

<script>
import axios from "@/axios.js"
import flatPickr from 'vue-flatpickr-component';
import { AgGridVue } from "ag-grid-vue"
import '@/assets/concept/scss/tabelaBasica.scss'
import 'flatpickr/dist/flatpickr.css';
import BtnAggridComponentRenderer from './BtnAggridComponent.vue';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import generico from '@/generico.js'

const URL_SERVLET = "/PedidosRotasRestServlet";
const NAME_ROUTE_EDIT = "roteirizacao-pedido-edit";
const ACAO_CRIAR_CARREGAMENTO = "CRIAR_CARREGAMENTO";
const ACAO_EXCLUIR_EM_LOTE = "EXCLUIR_EM_LOTE"

const CONSTANTE_OPCAO_DATA_ARRAY = [	
	{label:"Dt. Venda", data:"VENDA"},		
	{label:"Compr. Entrega", data:"COMPROMISSO_ENTREGA"},
	{label:"Dt. Renegociação", data:"RENEGOCIACAO"}
];

const CONSTANTE_OPCAO_STATUS_ITINERARIO_COMPLEMENTO = [	
    {label:"Aberto", data:"ABERTO"},		
		{label:"Adiada", data:"ADIADO"},
		{label:"Devolvido", data:"DEVOLVIDO"},
		{label:"Entregue", data:"ENTREGUE"},					
		{label:"Pendente", data:"PENDENTE"},
		{label:"End. Fechado", data:"ENDERECO_FECHADO"},					
		{label:"End. Errado", data:"ENDERECO_ERRADO"},
		{label:"End. Não Localizado", data:"ENDERECO_NAO_LOCALIZADO"},
		{label:"Não Informado", data:"NAO_INFORMADO"},

    {label:"Venda Finalizado", data:"VENDA_FINALIZADA"},
    {label:"Liberado p/ Separação", data:"LIBERADO_SEPARACAO"},
    {label:"Em Separação", data:"EM_SEPARACAO"},
    {label:"Separados", data:"SEPARADOS"},
    {label:"Liberados p/ Roteirização", data:"LIBERADO_ROTEIRIZACAO"},
    {label:"Não Entregues", data:"NAO_ENTREGUES"},
];

export default {
  components: {
    AgGridVue,
    flatPickr
  },
  data() {
    return {
      filtro: {vendedor: null, loja: null, zona: null, numeroPedido: null, numeroCarregamento: null, numeroLote: null, tipoDataPesquisa: 'VENDA', dataInicio: null,
      dataFim: null, statusItinerario: null, semCelular: false, naoRoteirizados: false },
      configuracaoGrid: { 
          context: null, 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: '' , field: 'numero', cellRendererFramework: BtnAggridComponentRenderer, colId: 'params', editable: false, width: 40},     
            { headerName: 'PEDIDO', field: 'numeroPedido', width: 90 },                 
            { headerName: 'DATA', field: 'dataPedidoFormatada', width: 90 },                 
            { headerName: 'COMPROMISSO', field: 'nome', width: 90 , cellRenderer : function(params) {
                  if (params.data.hasOwnProperty('dataHoraCompromissoEntregaFormatada')) {
                      return params.data.dataHoraCompromissoEntregaFormatada + (params.data.hasOwnProperty('dataHoraRenegociacaoEntregaFormatada') ?  ' <br/>' + params.data.dataHoraRenegociacaoEntregaFormatada : ''); 
                  } else {
                    return '';
                  }
                } 
            },
            { headerName: 'VALOR PEDIDO', field: 'valorPedido' , width: 90, valueGetter: function(params) { return generico.formatarNumero(params.data.valorPedido)} },
            { headerName: 'VENDEDOR/LOJA', width: 90, cellRenderer: function(params) { return params.data.nomeVendedor + '<br/>' +  params.data.nomeLoja } },                 
            { headerName: 'ZONA', field: 'nomeZona', width: 90 },
            { headerName: 'CELULAR', field: 'numeroGSM', width: 80 },
            { headerName: 'CARREGAMENTO / LOTE', width: 110,  cellRenderer: function(params) { return params.data.numeroCarregamento + '<br/>' + params.data.numeroLote } },
            { headerName: 'ITINERÁRIO', field: 'dataItinerarioViagem', valueGetter: function(params) {
                    if (params.data.statusViagem != '') {
                      if (params.data.statusViagem === "AGENDADA") {
                        return params.data.dataItinerarioViagem + ' ' + params.data.horaItinearioViagem + ' - ' + params.data.statusViagem.toUpperCase();
                      } else if (params.data.statusViagem === "ABERTA") {
                        return params.data.dataItinerarioViagem + ' ' + params.data.horaItinearioViagem + ' - ' + params.data.statusViagem.toUpperCase();
                    } else if (params.data.statusViagem === "EM ANDAMENTO") {
                        return params.data.dataItinerarioViagem + ' ' + params.data.horaItinearioViagem + ' - ' + params.data.statusViagem.toUpperCase() + '[' + params.data.statusItinerarioViagem.toUpperCase()+']';
                    } else if (params.data.statusViagem === "FINALIZADA") {
                        return params.data.dataItinerarioViagem + ' ' + params.data.horaItinearioViagem + ' - ' + params.data.statusViagem.toUpperCase() + '[' + params.data.statusItinerarioViagem.toUpperCase()+']';
                    } else {
                        return "";
                    }					     
                    } else {
                        if (params.data.statusPedido != "") {
                          return params.data.statusPedido.toUpperCase();
                        } else {
                          return "Aguardando Separação".toUpperCase();
                        }
                    }
              } 
            },
            { headerName: 'QTD', field: 'qtdItensPedido', width: 90, hide: true },
            { headerName: 'NOTA FISCAL', field: 'numeroNotaFiscal', width: 90, hide: true },
            { headerName: 'ENDEREÇO', field: 'endereco', width: 90, hide: true },
          ]
      },
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "U", 
          altInputClass: "vs-inputx vs-input--input normal text-sm  hasValue text-center",
          locale: PortugueseLocale
      },     
      dadosDaGrid: [],
      totalRegistros: 0,
      listaLojas: [],
      listaVendedores: [],
      listaZonas:[],
      exibirErro: false,
      mensagemErro: null,
      listaPedidosSelecionados: [],
      popUpSelecao : {
          popupActive: false ,
          numeroCarregamento: null        
      },
      listaOpcoesFiltroStatusItinerario: [],
    }
  },  
  computed: {   
     temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    temPermissaoGravar(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.grupoPodeSeAlterar;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },   
    filterSectionHeight() {
      return 320;   
    },    
    paginationPageSize() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetPageSize()
      else return 20  
    },
    totalPages() {
      if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.configuracaoGrid.gridApi) return this.configuracaoGrid.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.configuracaoGrid.gridApi.paginationGoToPage(val - 1)
      }
    },
    isPopUpRotasValido() {
      return (this.configuracaoPopUpRotas.viagensDoPopUp !== null && this.configuracaoPopUpRotas.viagensDoPopUp.length > 0);
    }
  },
  methods: {    
    limparFiltros() {
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = String(firstDay.getTime()/1000);
      this.filtro.dataFim = String(lastDay.getTime()/1000); 
      this.filtro.vendedor= null;
      this.filtro.loja = null;
      this.filtro.zona = null;
      this.filtro.numeroPedido = null;
      this.filtro.numeroCarregamento = null;
      this.filtro.numeroLote = null;
      this.filtro.tipoDataPesquisa = 'VENDA';      
      this.filtro.statusItinerario = null;
      this.filtro.semCelular = false;
      this.filtro.naoRoteirizados = false;
    },
    fetchLista(filtro) {  
      if ((!filtro.dataInicio && !filtro.dataFim) && !filtro.numeroPedido && !filtro.numeroCarregamento) {
         this.mensagemErro = "Informar um dos parametros.";
         this.exibirErro = true;
         return;
      } else if (filtro.numeroPedido && !filtro.numeroCarregamento) {
        if (!filtro.dataInicio || !filtro.dataFim) {
          this.mensagemErro = "Informe a data de inicio e fim";
          this.exibirErro = true;
          return;
        }
      }

      this.$vs.loading();    
      const params = new URLSearchParams();
      params.append('method', 'FindAll');
      params.append('orderDirection', 'ASC');
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      
      if (filtro.numeroPedido) {
          params.append('filter2', filtro.numeroPedido);
          params.append('numeroPedido', filtro.numeroPedido);
      } else if (filtro.dataInicio) {                
          params.append('campoData', filtro.tipoDataPesquisa);
          params.append('dataInicio', filtro.dataInicio*1000);
          params.append('dataFim', filtro.dataFim*1000);
          params.append('naoRoteirizados', filtro.naoRoteirizados);
          params.append('semCelular', filtro.semCelular);

          if (filtro.numeroPedido) {
            params.append('filter2', filtro.numeroPedido);
            params.append('numeroPedido', filtro.numeroPedido);
          }

          if (filtro.zona) {
            params.append('idZona', filtro.zona.id);
          }

          if (filtro.loja) {
            params.append('idLoja', filtro.loja.id);
          }

          if (filtro.vendedor) {
            params.append('idVendedor', filtro.vendedor.id);
          }

          if (filtro.numeroCarregamento) {
            params.append('numeroCarregamento', filtro.numeroCarregamento);          
          }

          if (filtro.numeroLote) {
            params.append('numeroLote', filtro.numeroLote);          
          }
          if (filtro.statusItinerario) {
            if (filtro.statusItinerario == 'VENDA_FINALIZADA') {
              params.append('gerenciamentoPedidos-Aba1', true);
            } else if (filtro.statusItinerario == 'LIBERADO_SEPARACAO') {
              params.append('gerenciamentoPedidos-Aba2', true);
            } else if (filtro.statusItinerario == 'EM_SEPARACAO') {
              params.append('gerenciamentoPedidos-Aba3', true);
            } else if (filtro.statusItinerario == 'SEPARADOS') {
              params.append('gerenciamentoPedidos-Aba4', true);
            } else if (filtro.statusItinerario == 'LIBERADO_ROTEIRIZACAO') {
              params.append('gerenciamentoPedidos-Aba5', true);
            } else if (filtro.statusItinerario == 'NAO_ENTREGUES') {
              params.append('gerenciamentoPedidos-Aba6', true);
            } else {
              params.append('statusItinerarioRota', filtro.statusItinerario);          
            }
          }
      } else {
          if (filtro.numeroCarregamento) {
            params.append('numeroCarregamento', filtro.numeroCarregamento);          
          }

          if (filtro.numeroLote) {
            params.append('numeroLote', filtro.numeroLote);          
          }
      }

      axios.post(URL_SERVLET, params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              this.dadosDaGrid = response.data;        
              this.totalRegistros = this.dadosDaGrid.length;                              
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - fetch Lista Despesas - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
     
      registro.dataHoraPedidoLong = String(registro.dataHoraPedidoLong / 1000);

      if (registro.hasOwnProperty('dataHoraCompromissoEntregaLong') && registro.dataHoraCompromissoEntregaLong > 0) {
        registro.dataHoraCompromissoEntregaLong = String(registro.dataHoraCompromissoEntregaLong / 1000);
      }
      if (registro.hasOwnProperty('dataHoraRenegociacaoEntregaLong') && registro.dataHoraRenegociacaoEntregaLong > 0) {
        registro.dataHoraRenegociacaoEntregaLong = String(registro.dataHoraRenegociacaoEntregaLong / 1000);
      }
      if (registro.hasOwnProperty('horaEntregaInicialLong') && registro.horaEntregaInicialLong > 0) {
        registro.horaEntregaInicialLong = String(registro.horaEntregaInicialLong / 1000);
      }
      if (registro.hasOwnProperty('horaEntregaFinalLong') && registro.horaEntregaFinalLong > 0) {
        registro.horaEntregaFinalLong = String(registro.horaEntregaFinalLong / 1000);
      }

      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {      
      var params = {columnSeparator: ';', fileName: 'Pedido.csv', allColumns: true};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    },
    fetchVendedores() {      
      const params = new URLSearchParams();
      params.append('method', 'FindAll');
      params.append('orderDirection', 'ASC');
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      
      axios.post("VendedorRotasRestServlet", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              this.listaVendedores = response.data;
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - fetchLista Fornecedor - " + error); 
      })    
    },
    fetchLojas() {      
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        
        axios.post("LojasRotasRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                this.listaLojas = response.data;
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - fetchLista Fornecedor - " + error); 
        })    
    },
    fetchZonas() {      
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        
        axios.post("ZonasRotasRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                this.listaZonas = response.data;
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - fetchLista Fornecedor - " + error); 
        })    
    },
    adcionarPedido(pedido) {
        if (this.listaPedidosSelecionados.indexOf(pedido) === -1) {
            this.listaPedidosSelecionados.push(pedido);
        } else {
            this.$vs.dialog({color:'danger', title: 'Atenção', 
            text: 'Pedido já incluído',
            acceptText:'OK'
      }) 
        }
    },
    removerPedido(pItem) {
        this.listaPedidosSelecionados.splice(this.listaPedidosSelecionados.indexOf(pItem), 1);
    },
    abrirPopUpSelecao() {
        this.popUpSelecao.popupActive = true;        
    },
    adicionarTodos() {
        if (Array.isArray(this.dadosDaGrid)) {
            this.listaPedidosSelecionados.push(...this.dadosDaGrid);
        } else {
            this.listaPedidosSelecionados.push(this.dadosDaGrid);
        }
    },
    limparListaSelecao() {
        this.listaPedidosSelecionados = null;
        this.listaPedidosSelecionados = [];
    },
    enviarRequisicao(acao) {
        
        this.$vs.loading()
        
        var listIdPedidos = null;

        for (var i= 0; i < this.listaPedidosSelecionados.length; i++){
            if (listIdPedidos === null) {
                listIdPedidos = new String();
                listIdPedidos = listIdPedidos + this.listaPedidosSelecionados[i].id;
            } else {
                listIdPedidos = listIdPedidos + "," + this.listaPedidosSelecionados[i].id;
            }
        }

        const params = new URLSearchParams();
        params.append('outputFormat', 'JSON');
        params.append('method', acao);
        params.append('idCliente', this.$store.state.AppActiveUser.id);  
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa); 

        if (this.popUpSelecao.numeroCarregamento) {
            params.append('numeroCarregamento', this.popUpSelecao.numeroCarregamento);	
        }
        params.append('listaIDs', listIdPedidos);
        
        axios.post("/PedidosRotasRestServlet", params, {              
            credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                    
                this.popUpSelecao.popupActive = false;       

                this.$vs.notify({
                    time:8000, title: "Atenção",  text: response.data.mensagem,
                    iconPack: 'feather', icon: 'icon-alert-circle', color: 'success'
                });
                
                if (acao !== ACAO_CRIAR_CARREGAMENTO) {
                    this.limparListaSelecao();
                }
                this.fetchLista(this.filtro);
                                    
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gerarNumeroCarregamento() {
        this.popUpSelecao.numeroCarregamento = generico.criarNumeroCarregamento();
    },
    fetchListaStatusItinerarios() {              
      const params = new URLSearchParams();            
      
      axios.post('/rest/StatusItinerarioViagemCustomizado/ListarStatusDoCliente', params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              this.listaOpcoesFiltroStatusItinerario = response.data;           
              this.listaOpcoesFiltroStatusItinerario = this.listaOpcoesFiltroStatusItinerario.concat(CONSTANTE_OPCAO_STATUS_ITINERARIO_COMPLEMENTO);
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
  },    
  created() {   
    this.listaOpcoesFiltroData = CONSTANTE_OPCAO_DATA_ARRAY;     
    this.ACAO_CRIAR_CARREGAMENTO = ACAO_CRIAR_CARREGAMENTO;
    this.ACAO_EXCLUIR_EM_LOTE = ACAO_EXCLUIR_EM_LOTE;
  },
  beforeMount() {
     this.configuracaoGrid.context = { componentParent: this };    
  },
  mounted() {
    if (this.$store.getters.filtroPedidos) {
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroPedidos));
    } else {
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = String(firstDay.getTime()/1000);
      this.filtro.dataFim = String(lastDay.getTime()/1000);
    }
    
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api        
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   
    this.fetchLista(this.filtro);
    this.fetchLojas();
    this.fetchVendedores();
    this.fetchZonas();
    this.fetchListaStatusItinerarios();
  },
  beforeDestroy() {    
    this.$store.dispatch('setarFiltro', {nomeTela: 'pedidos' , filtro: this.filtro});
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 380px);
  }
</style>

<style lang="scss">  
.con-vs-dialog {    
    .vs-dialog {
      max-width: 1000px;      
    }
}
</style>